import { PROJECT_DELIVERY_TYPE } from '../../../../../constants';

const localhost = window.location.hostname === 'localhost';

const getProjectSchema = () => {
  return {
    type: 'object',
    required: ['name', 'deliveryType', 'ip'],
    properties: {
      name: {
        type: 'string',
        title: 'Project Name',
        minLength: 5,
        maxLength: 15,
        placeholder: 'Name of the Project',
        default: localhost ? 'Test Project' : '',
      },
      deliveryType: {
        default: PROJECT_DELIVERY_TYPE.MIMS,
        type: 'string',
        title: 'Delivery Type',
        enum: [PROJECT_DELIVERY_TYPE.MIMS, PROJECT_DELIVERY_TYPE.EC],
      },
      ip: {
        type: 'string',
        format: 'ipv4',
        title: 'MIMS IP',
        placeholder: '111.224.2.11',
        default: localhost ? '111.224.2.11' : '',
      },
    },

    if: {
      properties: {
        deliveryType: {
          const: 'MIMS + Energy Connect',
        },
      },
    },
    then: {
      required: [
        'moduleId',
        'environment',
        'tenantId',
        'edgeId',
        'projectId',
        'typeDefAPI',
        'dataAccessAPI',
        'deviceTwinAPI',
      ],
      properties: {
        moduleId: {
          type: 'string',
          title: 'MIMS Module ID',
          placeholder: '00000000-0000-0000-0000-000000000000',
          format: 'uuid',
          default: localhost ? '8a196eef-f3dd-4576-b27a-6cd4b8f1eef2' : '',
        },
        environment: {
          type: 'string',
          title: 'EC Environment',
          maxLength: 15,
          placeholder: 'Name of the Environment',
          default: localhost ? 'test' : '',
        },
        tenantId: {
          type: 'string',
          title: 'Tenant ID',
          placeholder: '00000000-0000-0000-0000-000000000000',
          format: 'uuid',
          default: localhost ? '8a196eef-f3dd-4576-b27a-6cd4b8f1eef2' : '',
        },
        edgeId: {
          type: 'string',
          title: 'Edge ID',
          placeholder: '00000000-0000-0000-0000-000000000000',
          format: 'uuid',
          default: localhost ? '8a196eef-f3dd-4576-b27a-6cd4b8f1eef2' : '',
        },
        projectId: {
          type: 'string',
          title: 'Project ID',
          placeholder: '00000000-0000-0000-0000-000000000000',
          format: 'uuid',
          default: localhost ? '8a196eef-f3dd-4576-b27a-6cd4b8f1eef2' : '',
        },
        typeDefAPI: {
          type: 'string',
          title: 'EC Type Definition API',
          default: 'https://nothing.com',
        },
        dataAccessAPI: {
          type: 'string',
          title: 'EC Data Access API',
          default: 'https://nothing.com',
        },
        deviceTwinAPI: {
          type: 'string',
          title: 'EC Device Twin API',
          default: 'https://nothing.com',
        },
      },
    },
  };
};

const projectUISchema = {
  'ui:options': { orderable: false },
};

export { getProjectSchema, projectUISchema };
